import React, { useState } from "react";
import { Section } from "../../../components";
import { Search2, LoaderFullPage, useStyles } from "../../../components2";
import { CustomTable } from "../../../components2/Tables2";
import { shopList } from "../../../lib/ec2-api-lib";
import { isJson } from "../../../lib/utils";
import { debug } from "../../../settings";


const headerShopList = [
  { name: "storeCode", displayName: "가맹점코드", selectKey: true, keyName: "storeCode" },
  { name: "shopName", displayName: "가맹점명", sorting: true },
  { name: "posName", displayName: "사용 포스" },
  { name: "brandName", displayName: "브랜드명" },
  { name: "isBase", displayName: "기준 가맹점" },
  // { name: "addr1", displayName: "주소" },
]

export function MenuManager(props) {

  const { gStyle } = useStyles()

  const sName = debug ?  "샤브온당" : ""
  const [searchText, setSearchText] = useState(sName);
  const [isLoading, setIsLoading] = useState(false);
  const [visible, setVisible] = useState(false)
  const [storeList, setStoreList] = useState([])

  const onClickSearch = async () => {
    try {
      setIsLoading(true);

      let res = await shopList({ query: { shopName: searchText } })
      if (res.err) throw Error(res.err.message)
      let _storeList = res.result.Items

      // 
      // shopList에 null 제거
      // 
      const storeList2 = []
      _storeList.map(shop => {
        if (shop) storeList2.push(shop)
        return null
      })

      const storeList3 = storeList2.map(s => {
        const brandInfo = isJson(s.brandInfo) ? JSON.parse(s.brandInfo) : {}
        return {
          ...s,
          brandName: brandInfo.name,
          isBase: brandInfo.isBase
        }
      })

      setStoreList(storeList3)
      setVisible(true)
    } catch (e) {
      if (debug) console.log(e);
      alert(e.message);
    } finally {
      setIsLoading(false);
    }
  }

  const onClickItem = (store) => {
    alert(JSON.stringify(store, null, 2))
    // setVisible(false)
    // onSelectStore(store)
  }

  const onKeyUp = (e) => {
    if (e.code === "Enter") onClickSearch()
  }

  return (
    <Section bgColor="#fff">

      <p style={{ margin: "0px 0px 5px" }}>가맹점 이름</p>
      <Search2
        onChange={e => setSearchText(e.target.value)}
        btnDisabled="false"
        onClick={onClickSearch}
        onKeyUp={onKeyUp}
        value={searchText}
      />

      {storeList.length > 0 &&
        <div>
          <p style={gStyle.subtitle}>가맹점 수: {storeList.length}</p>
          <CustomTable
            {...props}
            tableHeader={headerShopList}
            rowItems={storeList}
            setRowItems={setStoreList}
            rowItemKey="shopName"
            // onClickItem={onSelectStore}
            onClickItem={(shop) => onClickItem(shop)}
          />
        </div>
      }

      {isLoading && <LoaderFullPage />}
    </Section>
  );
}
